import styled from 'styled-components';
import { size } from '../../layout/helpers';
import { fadeIn, noTransform } from '../../layout/keyframes';
import { ButtonReset } from '../../layout/reset';

const animationDuration = 200;

const closeBtnSize = (props: any) => props.theme.font.size.large;
const headingFontSize = (props: any) => props.theme.font.size.xxlarge;
const headingLineHeight = (props: any) => props.theme.font.lineHeight;

export const Wrapper = styled.div.attrs(() => ({
  role: 'dialog',
}))<{ $overlay?: boolean }>`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${size(2)};
  white-space: normal;
  text-align: left;
  z-index: ${({ theme }) => theme.zindex.modal};

  ${({ $overlay }) =>
    $overlay &&
    `
    background: rgba(0, 0, 0, 0.6);
  `}
`;

export const UiBlock = styled.div.attrs(() => ({
  'aria-hidden': 'true',
  role: 'button',
}))`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${(props) => props.theme.color.overlay.main};
  animation: ${fadeIn} ${animationDuration}ms ease;
  z-index: -1;

  @media (prefers-reduced-motion) {
    animation: none;
  }
`;

export const Dialog = styled.article<{ $customWidth?: string; $noBorderRadius?: boolean }>`
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.theme.color.bg.alt};
  z-index: 1;
  width: ${({ $customWidth }) => $customWidth || '100%'};
  max-width: ${({ $customWidth }) => $customWidth || '780px'};
  max-height: 70vh;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  border-radius: ${({ $noBorderRadius }) => ($noBorderRadius ? '0' : '12px')};
  overflow: hidden;
  transform: translateY(${size(2)});
  animation:
    ${fadeIn} ${animationDuration}ms ease,
    ${noTransform} ${animationDuration}ms ease forwards;
`;

export const Content = styled.div`
  flex: 1 1 auto;
  overflow-y: auto;
  min-height: 200px;
  max-height: calc(70vh - 80px);
`;

export const Header = styled.header`
  position: relative;
  display: flex;
  align-items: center;
  padding: ${size(3)};
  background-color: ${(props) => props.theme.color.bg.alt};
  z-index: 10;

  ${(props) => props.theme.breakpoint.LtSm} {
    padding: ${size(2)};
  }
`;

export const Heading = styled.div`
  flex: 1 1 auto;
  font-size: ${headingFontSize};
  line-height: ${headingLineHeight};
  font-weight: 600;
`;

export const Close = styled.div`
  flex-shrink: 0;
  margin-left: ${size(3)};
  display: flex;
  align-items: center;
`;

export const CloseBtn = styled(ButtonReset)`
  position: relative;
  display: block;
  font-size: ${closeBtnSize};
  color: ${(props) => props.theme.color.text.main};
  transform-origin: 50% 50%;
  transition: transform 200ms ease;
  z-index: 2;
  padding: ${size(2)};
  margin: -${size(2)};

  &:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: ${size(5)};
    height: ${size(5)};
    border-radius: 50%;
    background-color: ${(props) => props.theme.color.bg.main};
    opacity: 0;
    transform: translate(-50%, -50%);
    transition: opacity 200ms ease;
    z-index: -1;
  }

  :active {
    transform: scale(0.9);
  }

  &:hover {
    &:before {
      opacity: 1;
    }
  }
`;

export const Body = styled.div`
  padding: 0 ${size(3)} ${size(3)} ${size(3)};

  ${(props) => props.theme.breakpoint.LtSm} {
    padding: 0 ${size(2)} ${size(2)} ${size(2)};
  }
`;
